var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanadainline = function SvgCanadainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M0 .5h20v13H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.249.5h9.536v13H5.249z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "m10.12 9.213.089 1.675H9.85l.09-1.675a.18.18 0 0 0-.064-.147.19.19 0 0 0-.157-.043l-1.707.293.23-.622a.12.12 0 0 0-.039-.141l-1.87-1.48.422-.192a.13.13 0 0 0 .063-.064.12.12 0 0 0 .005-.09l-.37-1.11 1.077.224q.045.009.086-.012a.13.13 0 0 0 .059-.062l.208-.48.84.882a.13.13 0 0 0 .153.025.13.13 0 0 0 .057-.057.12.12 0 0 0 .011-.079L8.54 4.016l.65.367a.13.13 0 0 0 .18-.053l.66-1.265.66 1.265a.13.13 0 0 0 .078.065.13.13 0 0 0 .102-.012l.65-.367-.405 2.042a.12.12 0 0 0 .01.08.132.132 0 0 0 .21.032l.84-.883.209.48a.13.13 0 0 0 .059.062.13.13 0 0 0 .086.012l1.077-.224-.37 1.11q-.014.047.004.09a.13.13 0 0 0 .064.064l.42.192-1.869 1.48a.13.13 0 0 0-.04.141l.231.622-1.706-.293a.2.2 0 0 0-.157.043.18.18 0 0 0-.064.147"
  })));
};
export default SvgCanadainline;